import React from "react";
import Practice from "../../components/SPanel/Practice";
import PracticeStatistics from "../../components/SPanel/PracticeStatistics";

function PPTestare() {
   return (
      <main className="main">
         <section className="page-wrapper">
            <Practice />
            <PracticeStatistics />
         </section>
      </main>
   );
}

export default PPTestare;
